export const convertDayOfWeekArrayToNumber = array => {
  if (array.length > 7) {
    return null;
  }
  let count = 0;

  for (let i = 0; i < array.length; i++) {
    let day = array[i];
    // Subtract 1 from the day to convert from 1-indexed to 0-indexed
    day += 1;

    // Ensure that the day is valid (0-6 after adjustment)
    if (day >= 1 && day < 8) {
      count += 2 ** day;
    } else {
      // Return null or handle invalid day numbers
      return null;
    }
  }

  return count;
};

export const convertDayOfWeekNumberToArray = days => {
  if (days == null) {
    return [];
  }

  const dayArray = [];
  for (let i = 1; i < 8; i++) {
    dayArray.push(2 ** i);
  }

  return dayArray.filter((day, i) => dayArray.map(day => !!(day & days))[i]).map((day, i) => dayArray.indexOf(day));
};
